import { createMultiPartRequest, createRequest } from '../helpers/api_utils';
import { SearchApplicantFilter } from '../types/job_applicant';
import { JobApplicantSearchRequest } from '../types/JobOpenings';
import { apiUrl } from './api_url';

const apiEndpoint = apiUrl + '/job-applicant';

/** Talent Pool name/age filters. Most CVs state no age, so a range drops them unless asked. */
export interface TalentPoolFilters {
  name: string;
  ageMin: number | null;
  ageMax: number | null;
  includeUnknownAge: boolean;
}

export const EMPTY_POOL_FILTERS: TalentPoolFilters = { name: '', ageMin: null, ageMax: null, includeUnknownAge: false };

/**
 * Talent Pool search. With `search` text results are ranked by meaning; without it the filtered
 * pool is listed newest first and `score` is null. `folderId` narrows it to one Candi Bank folder
 * (404 if unknown).
 */
export function searchCandidates(search: string, page: number, page_size: number, top_x: number,
  folderId?: string | null, filters: TalentPoolFilters = EMPTY_POOL_FILTERS) {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: page_size.toString(),
    top_x: top_x.toString(),
  });
  if (search.trim()) params.set('search', search.trim());
  if (folderId) params.set('folder_id', folderId);
  if (filters.name.trim()) params.set('name', filters.name.trim());
  if (filters.ageMin != null) params.set('age_min', filters.ageMin.toString());
  if (filters.ageMax != null) params.set('age_max', filters.ageMax.toString());
  if ((filters.ageMin != null || filters.ageMax != null) && filters.includeUnknownAge) {
    params.set('include_unknown_age', 'true');
  }
  const url = `${apiEndpoint}/search_candidates?${params}`;
  return fetch(createRequest(url, 'POST', 'application/json', true));
}

export async function jobApplicantTwoD(
  searchObject: JobApplicantSearchRequest,
) {
  return fetch(
    createRequest(
      `${apiEndpoint}/2d-graph`,
      'POST',
      'application/json',
      true,
      searchObject,
    ),
  );
}

